<nz-affix [nzOffsetTop]="0">
  <hx-breadcrumbs></hx-breadcrumbs>
  <nz-page-header nzBackIcon [nzGhost]="false">
    <nz-page-header-title>{{(isEdit ? 'action.edit' : 'action.create') | transloco}}</nz-page-header-title>
  </nz-page-header>
</nz-affix>

<nz-skeleton [nzActive]="true" [nzLoading]="isLoading.model" *transloco="let tr; prefix: 'productCategories'; scope: 'product-categories'">
  <form class="hx-form" nz-form [nzLayout]="'vertical'" [formGroup]="form" (ngSubmit)="submitForm()">
    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.brandId')}}</nz-form-label>
          <nz-form-control>
            <hx-brand-select formControlName="brandId"></hx-brand-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col class="hx-col-1">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.enabled')}}</nz-form-label>
          <nz-form-control>
            <nz-radio-group formControlName="enabled">
              <label nz-radio [nzValue]="true">{{'yes' | transloco}}</label>
              <label nz-radio [nzValue]="false">{{'no' | transloco}}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col class="hx-col-1_2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.title')}}</nz-form-label>
          <nz-form-control>
            <hx-label-edit formControlName="title"></hx-label-edit>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.seq')}}</nz-form-label>
          <nz-form-control>
            <nz-input-number formControlName="seq" [nzMin]="1" [nzMax]="1000" [nzStep]="1"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <div nz-row [nzGutter]="8">
      <div nz-col>
        <nz-form-item>
          <nz-form-label>{{tr('form.type')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select formControlName="type" [enumType]="ProductCategoryType" enumName="ProductCategoryType"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <div nz-col class="hx-col-2">
        <nz-form-item>
          <nz-form-label nzRequired>{{tr('form.components')}}</nz-form-label>
          <nz-form-control>
            <hx-enum-select formControlName="components" [enumType]="ComponentType" enumName="ComponentType" [hxMode]="'multiple'"></hx-enum-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-alert *ngIf="form.invalid" nzType="error" [nzMessage]="'error.fillRequiredFields' | transloco" nzShowIcon></nz-alert>

    <div nz-row [nzGutter]="8" class="cp_actions">
      <div nz-col>
        <nz-form-item>
          <nz-form-control>
            <button [nzLoading]="isSaving" [disabled]="form.pristine || form.pending || form.disabled" type="submit" nz-button nzType="primary">
              <i nz-icon nzType="save" nzTheme="outline"></i> {{'button.save' | transloco}}
            </button>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col>
        <nz-tag nzColor="success" *ngIf="form.pristine && model.id">
          <i nz-icon nzType="check-circle"></i>
          <span>{{'form.saved' | transloco}}</span>
        </nz-tag>
      </div>
    </div>
  </form>
</nz-skeleton>
